export const RQStoryKey = {
  stories: ['stories'] as const,
  story: (storyId: number) => ['storyies', storyId] as const,
};
